import { render, staticRenderFns } from "./Electronics.vue?vue&type=template&id=7ca1e16a&scoped=true&"
import script from "./Electronics.vue?vue&type=script&lang=js&"
export * from "./Electronics.vue?vue&type=script&lang=js&"
import style0 from "./Electronics.vue?vue&type=style&index=0&id=7ca1e16a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca1e16a",
  null
  
)

export default component.exports